import React from 'react';
import { HeadProvider, Title, Meta } from 'react-head';
import { useConfiguration } from 'components/contexts/ConfigurationContext';
import Favicon from 'react-favicon';

export default function Head() {
  let { config, loading, isGreyLabel } = useConfiguration();

  const { icon, logo, name, description } = config;
  const error = !loading && !isGreyLabel && !name;

  // Determine favicon URL based on mode
  const getFaviconUrl = () => {
    // If whitelabel mode and still loading, show placeholder
    if (!isGreyLabel && loading) {
      return '/images/placeholder-favicon.png';
    }

    // If error state, show default only in grey label mode, placeholder in whitelabel
    if (error) {
      return isGreyLabel ? '/images/ico.png' : '/images/placeholder-favicon.png';
    }

    // Show company favicon or fallback to default in grey label mode, placeholder in whitelabel
    return icon ?? logo ?? (isGreyLabel ? '/images/ico.png' : '/images/placeholder-favicon.png');
  };

  const faviconUrl = getFaviconUrl();

  return (
    <React.Fragment>
      {faviconUrl && <Favicon url={faviconUrl} />}
      <HeadProvider>
        <Title>
          {loading
            ? '...'
            : error
            ? 'App unavailable'
            : `${name ?? 'Rehive'} Wallet`}
        </Title>
        <Meta name="description" content={description} />
      </HeadProvider>
    </React.Fragment>
  );
}
